
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.027 15.991a4.012 4.012 0 01-4.018-4.018c0-2.196 1.768-3.964 4.018-3.964a3.955 3.955 0 013.964 3.964c0 2.25-1.768 4.018-3.964 4.018z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M23.92 7.045c-.108-1.929-.536-3.643-1.929-5.036C20.598.616 18.884.188 16.955.08c-1.982-.107-7.928-.107-9.91 0-1.929.107-3.59.536-5.036 1.929C.616 3.402.188 5.116.08 7.045c-.107 1.982-.107 7.928 0 9.91.107 1.929.536 3.59 1.929 5.036 1.446 1.393 3.107 1.822 5.036 1.929 1.982.107 7.928.107 9.91 0 1.929-.108 3.643-.536 5.036-1.929 1.393-1.446 1.822-3.107 1.929-5.036.107-1.982.107-7.928 0-9.91zM12.027 5.813c-3.429 0-6.16 2.785-6.16 6.16a6.128 6.128 0 006.16 6.16c3.375 0 6.16-2.731 6.16-6.16 0-3.375-2.785-6.16-6.16-6.16zm-4.018 6.16a4.012 4.012 0 004.018 4.018c2.196 0 3.964-1.768 3.964-4.018a3.955 3.955 0 00-3.964-3.964c-2.25 0-4.018 1.768-4.018 3.964zm10.393-7.821a1.44 1.44 0 011.446 1.446 1.44 1.44 0 01-1.446 1.447 1.44 1.44 0 01-1.447-1.447 1.44 1.44 0 011.447-1.446z","fill":"currentColor"}})])
          )
        }
      }
    